import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M15.78 7.72a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06 0L4.22 8.78a.75.75 0 1 1 1.06-1.06L10 12.44l4.72-4.72a.75.75 0 0 1 1.06 0Z" }) }), l = s.forwardRef(a);
export {
  l as F
};
//# sourceMappingURL=ChevronDown20.NQYj4T82.js.map
